import { DataProvider } from 'react-admin'
import { DeviceManagementContainerDto } from '../../dto/device/device-management/device-management-containers/DeviceManagementContainer.dto'

const fakeContainers: DeviceManagementContainerDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeContainers, total: fakeContainers.length }),
} as DataProvider

export default provider
